import { render, staticRenderFns } from "./Partner.vue?vue&type=template&id=265d8d4e&scoped=true&"
import script from "./Partner.vue?vue&type=script&lang=js&"
export * from "./Partner.vue?vue&type=script&lang=js&"
import style0 from "./Partner.vue?vue&type=style&index=0&id=265d8d4e&prod&scoped=true&lang=css&"
import style1 from "./Partner.vue?vue&type=style&index=1&id=265d8d4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265d8d4e",
  null
  
)

export default component.exports